import { cursorPaginationFieldPolicy } from '../../../../utils/policies/cursorPaginationFieldPolicy';
import type { TypePolicies } from '../../../../utils/types/TypePolicies';

export const typePolicies: TypePolicies = {
  Query: {
    fields: {
      suggestedMembers: cursorPaginationFieldPolicy([
        '$filter',
        ['query'],
        '$resourceId',
      ]),
    },
  },
};
